import CheckDocument from './views/checkDocument.c';
export default CheckDocument;
